import { combineReducers, createStore } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  sidebarReducer,
  themeReducer,
  loadingReducer,
  pendingMedicationReducer,
  schoolTermReducer,
  pendencySummaryReducer,
} from '../../redux/reducers/index';

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  loading: loadingReducer,
  pendingApplications: pendingMedicationReducer,
  listOfTerms: schoolTermReducer,
  pendencySummary: pendencySummaryReducer,
});

const store = createStore(reducer);

export default store;
